import { createAction } from 'typesafe-actions';

import { ConversionProjectionDtoFramedResultDto, CustomerConversionSettingDto } from 'common/api/autogenerated/trading-gateway';

import actionTypes from './exchange.actionTypes';

export const actionLoadingGetExchangeHistory = createAction(actionTypes.LOADING_GET_EXCHANGE_HISTORY)<void>();
export const actionSuccessGetExchangeHistory = createAction(actionTypes.SUCCESS_GET_EXCHANGE_HISTORY, (data: ConversionProjectionDtoFramedResultDto) => data)<ConversionProjectionDtoFramedResultDto>();
export const actionErrorGetExchangeHistory = createAction(actionTypes.ERROR_GET_EXCHANGE_HISTORY)<void>();

export const actionLoadingGetExchangeSettings = createAction(actionTypes.LOADING_GET_EXCHANGE_SETTINGS)<void>();
export const actionSuccessGetExchangeSettings = createAction(actionTypes.SUCCESS_GET_EXCHANGE_SETTINGS, (data: CustomerConversionSettingDto) => data)<CustomerConversionSettingDto>();
export const actionErrorGetExchangeSettings = createAction(actionTypes.ERROR_GET_EXCHANGE_SETTINGS)<void>();
export const actionSaveExchangeSettings = createAction(actionTypes.SAVE_EXCHANGE_SETTINGS, (data: CustomerConversionSettingDto) => data)<CustomerConversionSettingDto>();
